// GSAP Animations and Theme JavaScript

// Register GSAP ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// Global flag to control when WARD product hover is allowed
let wardProductHoverEnabled = false;

// Initialize animations when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  initHeroAnimations();
  initScrollAnimations();
  initWardProductsEqualHeight();
  initWardProductHoverAnimations();
  initProductInteractions();
  initLifestyleImageAnimation();
  initFooterNewsletterKlaviyo();
  initCartUpdates();
  initMobileMenu();
});

// Hero Banner Animations
function initHeroAnimations() {
  const header = document.querySelector('.site-header');
  const heroBanner = document.querySelector("#shopify-section-template--19403881545882__hero-banner");
  const heroLogo = document.querySelector('.pb-row-splash-page__headerLogo, .pb-row-splash-page__lottie');
  const headerLogo = document.querySelector('.header-center .logo-img');
  
  // If no hero banner, show header immediately (for non-homepage pages)
  if (!heroBanner && header) {
    header.classList.add('header-visible');
    if (headerLogo) {
      gsap.set(headerLogo, { opacity: 1 });
    }
    return;
  }
  
  // Animate logo shrink from hero to header (only on homepage with hero)
  if (heroLogo && headerLogo && header && heroBanner) {
    ScrollTrigger.create({
      trigger: heroBanner,
      start: "top top",
      end: "bottom top",
      scrub: true,
      onUpdate: (self) => {
        const progress = self.progress;
        if (progress > 0) {
          // Shrink hero logo as we scroll
          const scale = 1 - (progress * 0.7); // Shrink to 30% of original size
          gsap.set(heroLogo, {
            scale: Math.max(scale, 0.3),
          });
        }
      },
      onLeave: () => {
        // Ensure header logo is fully visible when hero is past
        gsap.set(headerLogo, { opacity: 1 });
      },
      onEnterBack: () => {
        // Reset hero logo when back at top
        gsap.set(heroLogo, { scale: 1, opacity: 1 });
        gsap.set(headerLogo, { opacity: 0 });
      }
    });
  }
  
  // Show/hide header on scroll (only on homepage with hero)
  if (header && heroBanner) {
    const mainContent = document.querySelector('main#MainContent');
    
    ScrollTrigger.create({
      trigger: heroBanner,
      start: "bottom top",
      end: "bottom top",
      onEnter: () => {
        header.classList.add('header-visible');
        if (mainContent) {
          mainContent.style.paddingTop = '80px';
        }
      },
      onLeaveBack: () => {
        header.classList.remove('header-visible');
        if (mainContent) {
          mainContent.style.paddingTop = '0';
        }
      }
    });
  }

  // Products section scroll animation
  gsap.to("#shopify-section-template--19403881545882__hero-banner", {
    yPercent: -100, // Reduced from -100 to move less (50% instead of 100%)
    scrollTrigger: {
      trigger: "#shopify-section-template--19403881545882__hero-banner",
      pin: true,
      scrub: 3, // Increased from 3 to make it slower/smoother
      pinSpacing: true,
      onLeave: () => {
        // Enable hover when hero has fully scrolled away
        wardProductHoverEnabled = true;
        const wardSection = document.querySelector('.ward-products-section');
        if (wardSection) {
          wardSection.classList.remove('ward-products-hover-disabled');
        }
        // Show header when hero is scrolled past
        if (header) {
          header.classList.add('header-visible');
        }
      },
      onEnterBack: () => {
        // Disable hover again when hero comes back into view at the top
        wardProductHoverEnabled = false;
        const wardSection = document.querySelector('.ward-products-section');
        if (wardSection) {
          wardSection.classList.add('ward-products-hover-disabled');
        }
        // Hide header when back at top
        if (header) {
          header.classList.remove('header-visible');
        }
      }
    }
  });

  ScrollTrigger.create({
    trigger: "#shopify-section-template--19403881545882__ward-products",
    start: "top top",
    end: "+=100%",
    pin: "#shopify-section-template--19403881545882__ward-products",
    pinSpacing: true
  });

  // Initially disable hover while hero is visible at top
  wardProductHoverEnabled = false;
  const wardSection = document.querySelector('.ward-products-section');
  if (wardSection) {
    wardSection.classList.add('ward-products-hover-disabled');
  }

  // Hero CTA animation (appear from bottom to top about halfway through intro)
  const heroCta = document.querySelector('.pb-row-splash-page__cta');
  if (heroCta && typeof gsap !== 'undefined') {
    // Start hidden, slightly below
    gsap.set(heroCta, { opacity: 0, y: 30 });

    gsap.to(heroCta, {
      opacity: 1,
      y: 0,
      duration: 1,
      delay: 1.2, // roughly halfway through the flower + logo intro
      ease: 'power3.out'
    });

    // Smooth scroll function with easing
    function smoothScrollTo(target, duration) {
      const start = window.pageYOffset;
      const distance = target - start;
      let startTime = null;

      function easeInOutQuart(t) {
        return t < 0.5 
          ? 8 * t * t * t * t 
          : 1 - Math.pow(-2 * t + 2, 4) / 2;
      }

      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        const ease = easeInOutQuart(progress);

        window.scrollTo(0, start + distance * ease);

        if (timeElapsed < duration) {
          requestAnimationFrame(animation);
        }
      }

      requestAnimationFrame(animation);
    }

    heroCta.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      // Scroll to the products section
      const productsSection = document.querySelector('.ward-products-section');
      if (!productsSection) {
        console.warn('Products section not found');
        return;
      }

      const header = document.querySelector('.site-header');
      const headerHeight = header && header.classList.contains('header-visible') ? header.offsetHeight : 80;
      
      // Get the target position - account for pinned sections
      const heroBanner = document.querySelector("#shopify-section-template--19403881545882__hero-banner");
      const heroHeight = heroBanner ? heroBanner.offsetHeight : 0;
      const extraOffset = 100; // small gap so header doesn't cover the content
      
      // Calculate position: hero height + products section position - header
      const sectionRect = productsSection.getBoundingClientRect();
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop || window.scrollY || 0;
      
      // If we're at the top, we need to scroll past the hero
      let targetPosition;
      if (currentScroll < heroHeight) {
        // We're still in the hero, scroll to just past it
        targetPosition = heroHeight + sectionRect.top - headerHeight + extraOffset;
        console.log('Scrolling to:', targetPosition, 'Current scroll:', currentScroll, 'Hero height:', heroHeight);
      } else {
        // We're past the hero, scroll to the section
        targetPosition = sectionRect.top + currentScroll - headerHeight + extraOffset;
        console.log('Scrolling to:', targetPosition, 'Current scroll:', currentScroll, 'Hero height:', heroHeight);
      }

      // Use smooth scroll with easing
      console.log('Scrolling to:', targetPosition, 'Current scroll:', currentScroll, 'Hero height:', heroHeight);
      smoothScrollTo(Math.max(0, targetPosition), 1500);
    });
  }
}

// Scroll-triggered Animations (global fade-in for text and images)
function initScrollAnimations() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  // Headings, paragraphs, images, product links, header links, ingredients toggle, philosophy text, and footer items fade in + move up slightly on scroll
  const elements = gsap.utils.toArray('h1, h2, h3, h4, h5, h6, p, img, a.ward-product-text-link, a.nav-link, a.navbar-brand, .ingredients-toggle, .philosophy-text, .ward-footer h3, .ward-footer a, .ward-footer p, .ward-footer li, .ward-footer-nav, .ward-footer-heading, .ward-footer-link, .ward-footer-copyright');

  elements.forEach((el) => {
    // Skip elements that are hidden or inside the hero logo/Lottie container
    if (!(el instanceof HTMLElement)) return;
    if (el.closest('.pb-row-splash-page__headerLogo, .pb-row-splash-page__lottie')) return;
    
    // Skip hero banner background image and product images
    if (el.classList.contains('pb-row-splash-page__img') || 
        el.classList.contains('image-as-background') ||
        el.classList.contains('ward-product-image')) return;
    
    // Skip if inside hero banner section
    if (el.closest('#shopify-section-template--19403881545882__hero-banner')) return;
    
    // Skip product cards and columns to avoid interfering with hover
    if (el.closest('.ward-product-card, .ward-products-section .col-12')) return;
    
    // Skip footer logo to ensure it's always visible
    if (el.classList.contains('ward-footer-logo') || el.closest('.ward-footer-logo')) return;
    
    // Skip ingredient images to ensure they're always visible
    if (el.closest('.ingredients-images, .ingredient-image, .ingredients-slider')) return;

    // Set initial state
    gsap.set(el, { opacity: 0, y: 20 });

    // Animate on scroll
    gsap.to(el, {
      scrollTrigger: {
        trigger: el,
        start: 'top 85%',
        toggleActions: 'play none none none',
        once: true
      },
      opacity: 1,
      y: 0,
      duration: 1.6,
      ease: 'power2.out'
    });
  });
}

// Lifestyle Image Scroll Animation
function initLifestyleImageAnimation() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  const lifestyleImage = document.querySelector('.lifestyle-image');
  const lifestyleImageWrapper = document.querySelector('.lifestyle-image-wrapper');
  const lifestyleOverlay = document.querySelector('.lifestyle-overlay');
  const lifestyleSection = document.querySelector('.product-lifestyle');

  if (!lifestyleImage || !lifestyleImageWrapper || !lifestyleSection) return;

  // Wait for layout to be ready
  setTimeout(() => {
    // Determine if mobile or desktop
    const isMobile = window.innerWidth <= 768;
    
    // Use uniform scale to maintain aspect ratio (stretches proportionally)
    // Scale from left side to fill from left to middle of page
    const scaleValue = isMobile ? 1.4 : 1.25;
    
    // Set transform values - uniform scale maintains proportions
    const transformValues = isMobile 
      ? { x: '-20%', y: 0, scale: scaleValue, opacity: 1 }
      : { x: '-15%', y: 0, scale: scaleValue, opacity: 1 };

    // Set transform origin to left center so it scales from the left side
    gsap.set(lifestyleImage, {
      transformOrigin: 'left center'
    });

    // Create one-time animation triggered on scroll when middle of section is in viewport
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: lifestyleSection,
        start: 'center center', // Trigger when middle of section reaches center of viewport
        toggleActions: 'play none none none',
        once: true
        // Keep overflow hidden to prevent overlap with title
      }
    });

    // Animate the image to final state
    tl.to(lifestyleImage, {
      ...transformValues,
      duration: 1,
      ease: 'power2.out'
    });

    // Keep overlay centered in wrapper (no animation needed, CSS handles it)
    // But ensure it's positioned correctly
    if (lifestyleOverlay) {
      // The overlay is already centered via CSS, but we can ensure it stays put
      gsap.set(lifestyleOverlay, {
        x: 0,
        y: 0
      });
    }
  }, 100);
}

// Product Interactions
function initProductInteractions() {
  // Thumbnail image switching
  const thumbnailImages = document.querySelectorAll('.thumbnail-image');
  const mainProductImage = document.getElementById('main-product-image');

  thumbnailImages.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      if (mainProductImage) {
        // Animate image change
        gsap.to(mainProductImage, {
          opacity: 0,
          scale: 0.9,
          duration: 0.2,
          onComplete: function() {
            mainProductImage.src = this.dataset.mainImage;
            gsap.to(mainProductImage, {
              opacity: 1,
              scale: 1,
              duration: 0.3
            });
          }
        });
      }

      // Update active thumbnail
      thumbnailImages.forEach(img => img.style.borderColor = 'transparent');
      this.style.borderColor = 'var(--primary-color)';
    });
  });

  // Legacy product card hover effects (generic cards, not WARD cards)
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach(card => {
    card.addEventListener('mouseenter', function() {
      gsap.to(this, {
        scale: 1.02,
        duration: 0.3,
        ease: 'power2.out'
      });
    });

    card.addEventListener('mouseleave', function() {
      gsap.to(this, {
        scale: 1,
        duration: 0.3,
        ease: 'power2.out'
      });
    });
  });

  // Make WARD homepage product image wrappers clickable (navigate to product)
  const wardImageWrappers = document.querySelectorAll('.ward-products-section .ward-product-image-wrapper');

  wardImageWrappers.forEach((wrapper) => {
    // Visual cue that the area is clickable
    wrapper.style.cursor = 'pointer';

    wrapper.addEventListener('click', (event) => {
      // If clicking directly on a button or link inside the overlay, let that handle navigation
      if (event.target.closest('.ward-preorder-button, a')) {
        return;
      }

      const card = wrapper.closest('.ward-product-card');
      if (!card) return;

      // Reuse the existing product title link as the canonical URL
      const textLink = card.querySelector('.ward-product-text-link');
      if (textLink && textLink.href) {
        window.location.href = textLink.href;
      }
    });
  });
}

// Footer Newsletter → Klaviyo list subscription
function initFooterNewsletterKlaviyo() {
  // Try to be resilient to how Shopify renders the form:
  // 1) Prefer the explicit ID if it exists
  // 2) Fallback to the first form inside the footer newsletter block
  let form = document.getElementById('ward-newsletter-form');
  if (!form) {
    const newsletterContainer = document.querySelector('.ward-footer .ward-newsletter') || document.querySelector('.ward-newsletter');
    if (newsletterContainer) {
      form = newsletterContainer.querySelector('form');
    }
  }
  if (!form) return;

  // Avoid native browser submission reloading the page
  form.setAttribute('novalidate', 'novalidate');

  const emailInput = form.querySelector('.ward-email-input');
  const submitButton = form.querySelector('.ward-email-submit');
  const emailWrapper = form.querySelector('.ward-email-input-wrapper');
  const consentWrapper = form.querySelector('.ward-checkbox-wrapper');
  const messageElId = 'ward-newsletter-message';
  let messageEl = document.getElementById(messageElId);

  if (!messageEl) {
    messageEl = document.createElement('p');
    messageEl.id = messageElId;
    messageEl.className = 'ward-newsletter-message';
    const container = form.querySelector('.ward-newsletter-form') || form;
    container.appendChild(messageEl);
  }

  function handleNewsletterSubmit(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!emailInput) return;

    const email = emailInput.value.trim();
    if (!email) {
      messageEl.textContent = 'Please enter a valid email.';
      messageEl.classList.remove('success');
      messageEl.classList.add('error');
      return false;
    }

    // Optional: check consent checkbox if present
    const consentCheckbox = form.querySelector('.ward-checkbox-wrapper input[type=\"checkbox\"]');
    if (consentCheckbox && !consentCheckbox.checked) {
      messageEl.textContent = 'Please confirm you agree to the privacy policy.';
      messageEl.classList.remove('success');
      messageEl.classList.add('error');
      return false;
    }

    // Klaviyo list subscribe endpoint (public)
    const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
    const params = new URLSearchParams();
    params.append('a', 'WGPH5n');      // Public API key
    params.append('g', 'S5zmFn');      // List ID
    params.append('email', email);

    // Basic loading state
    form.classList.add('is-submitting');
    messageEl.textContent = '';
    messageEl.classList.remove('success', 'error');

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: params.toString()
    })
      .then(response => response.json().catch(() => ({})))
      .then(data => {
        form.classList.remove('is-submitting');

        // Klaviyo returns { success: true } on success
        if (data && (data.success || data.subscription || data.message === 'Subscribed')) {
          messageEl.textContent = 'WELCOME TO THE WORLD OF WARD PARIS';
          messageEl.classList.remove('error');
          messageEl.classList.add('success');
          emailInput.value = '';

          // Hide input + consent when successfully subscribed
          if (emailWrapper) {
            emailWrapper.style.display = 'none';
          }
          if (consentWrapper) {
            consentWrapper.style.display = 'none';
          }
        } else {
          messageEl.textContent = (data && data.message) ? data.message : 'Something went wrong. Please try again.';
          messageEl.classList.remove('success');
          messageEl.classList.add('error');
        }
      })
      .catch(() => {
        form.classList.remove('is-submitting');
        messageEl.textContent = 'Something went wrong. Please try again.';
        messageEl.classList.remove('success');
        messageEl.classList.add('error');
      });

    // Extra safety: ensure no default navigation happens
    return false;
  }

  // Intercept form submission (e.g., pressing Enter)
  form.addEventListener('submit', handleNewsletterSubmit);

  // Also intercept explicit clicks on the arrow button to prevent page reload
  if (submitButton) {
    submitButton.addEventListener('click', handleNewsletterSubmit);
  }

  // If user toggles consent after an error, clear the error message
  const consentCheckbox = form.querySelector('.ward-checkbox-wrapper input[type="checkbox"]');
  if (consentCheckbox) {
    consentCheckbox.addEventListener('change', () => {
      if (consentCheckbox.checked && messageEl.classList.contains('error')) {
        messageEl.textContent = '';
        messageEl.classList.remove('error');
      }
    });
  }
}

// Ward Products - Equalize card heights based on non-hover state
function initWardProductsEqualHeight() {
  const wardSection = document.querySelector('.ward-products-section');
  if (!wardSection) return;

  function setWardProductHeights() {
    const rows = wardSection.querySelectorAll('.row');
    rows.forEach(row => {
      const wrappers = row.querySelectorAll('.ward-product-image-wrapper');
      if (!wrappers.length) return;

      // Reset any previously set heights to measure the natural (non-hover) height
      wrappers.forEach(wrapper => {
        wrapper.style.height = '';
      });

      // Measure the tallest wrapper in this row (non-hover state)
      let maxHeight = 0;
      wrappers.forEach(wrapper => {
        const rect = wrapper.getBoundingClientRect();
        if (rect.height > maxHeight) {
          maxHeight = rect.height;
        }
      });

      // Apply that height to all wrappers in the row so hover / shrink states match
      if (maxHeight > 0) {
        wrappers.forEach(wrapper => {
          wrapper.style.height = maxHeight + 'px';
        });
      }
    });
  }

  // Initial calculation once layout is ready
  // Use requestAnimationFrame to ensure CSS has been applied
  window.requestAnimationFrame(setWardProductHeights);

  // Recalculate on resize, but only when the section is not hovered
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if (!wardSection.matches(':hover')) {
        setWardProductHeights();
      }
    }, 150);
  });
}

// WARD Products - GSAP hover animations with smooth sliding
function initWardProductHoverAnimations() {
  // Disable hover effects on mobile
  if (window.innerWidth <= 768) {
    return;
  }

  const wardSection = document.querySelector('.ward-products-section');
  if (!wardSection || typeof gsap === 'undefined') {
    console.warn('Ward products section or GSAP not found');
    return;
  }

  const rows = wardSection.querySelectorAll('.row');
  if (!rows.length) {
    console.warn('No rows found in ward products section');
    return;
  }

  rows.forEach(row => {
    // Select columns with the full class list (col-12 col-md-6 col-lg-4)
    const columns = row.querySelectorAll('.col-12.col-md-6.col-lg-4, .col-12');
    const cards = row.querySelectorAll('.ward-product-card');
    
    if (!cards.length || !columns.length) {
      console.warn('No cards or columns found in row');
      return;
    }

    // Store default values
    const defaultFlex = '0 0 33.333333%';
    const defaultMaxWidth = '33.333333%';
    
    // Track currently hovered column to prevent flicker
    let currentHoveredIndex = null;
    let leaveTimeout = null;

    columns.forEach((column, index) => {
      const card = column.querySelector('.ward-product-card');
      if (!card) return;
      
      const imageWrapper = card.querySelector('.ward-product-image-wrapper');
      const productImage = card.querySelector('.ward-product-image');
      const overlay = card.querySelector('.ward-product-hover-overlay');
      const isRapide = card.classList.contains('ward-product-rapide');
      
      // Copy background-image to CSS variable for pseudo-element
      if (imageWrapper) {
        // Read from inline style attribute directly
        const inlineStyle = imageWrapper.getAttribute('style') || '';
        const bgImageMatch = inlineStyle.match(/background-image:\s*([^;]+)/i);
        let bgImage = null;
        
        if (bgImageMatch) {
          bgImage = bgImageMatch[1].trim();
        } else {
          // Fallback to computed style
          bgImage = getComputedStyle(imageWrapper).backgroundImage;
        }
        
        if (bgImage && bgImage !== 'none' && bgImage !== '' && bgImage !== 'initial' && bgImage !== 'inherit') {
          // Set it as a CSS variable so ::before can use it
          imageWrapper.style.setProperty('--bg-image', bgImage);
        }
      }
      
      // Hover enter handler
      const handleMouseEnter = function(e) {
        // If global flag says hover is disabled (hero still in view), do nothing
        if (!wardProductHoverEnabled) return;
        // Prevent event from bubbling
        if (e) {
          e.stopPropagation();
        }
        
        // Clear any pending leave timeout
        if (leaveTimeout) {
          clearTimeout(leaveTimeout);
          leaveTimeout = null;
        }
        
        // If we're already hovering this column, don't do anything
        if (currentHoveredIndex === index) return;
        
        // Reset previous hovered column immediately if switching
        if (currentHoveredIndex !== null && currentHoveredIndex !== index) {
          const prevColumn = columns[currentHoveredIndex];
          const prevCard = prevColumn.querySelector('.ward-product-card');
          const prevImageWrapper = prevCard ? prevCard.querySelector('.ward-product-image-wrapper') : null;
          const prevProductImage = prevCard ? prevCard.querySelector('.ward-product-image') : null;
          const prevOverlay = prevCard ? prevCard.querySelector('.ward-product-hover-overlay') : null;
          
          // Reset previous column immediately
          prevColumn.style.setProperty('flex', defaultFlex, 'important');
          prevColumn.style.setProperty('max-width', defaultMaxWidth, 'important');
          
          if (prevImageWrapper) {
            prevImageWrapper.style.setProperty('justify-content', 'center', 'important');
            gsap.to(prevImageWrapper, {
              paddingLeft: 20,
              paddingRight: 20,
              '--bg-scale': 1.10,
              duration: 0.3,
              ease: 'power2.out'
            });
          }
          
          if (prevProductImage) {
            // Ensure previous image is visible when resetting
            gsap.to(prevProductImage, {
              scale: 1,
              opacity: 1,
              visibility: 'visible',
              duration: 0.2,
              ease: 'power2.out'
            });
          }
          
          if (prevOverlay) {
            gsap.to(prevOverlay, {
              opacity: 0,
              duration: 0.2,
              ease: 'power2.out',
              onComplete: function() {
                prevOverlay.style.pointerEvents = 'none';
              }
            });
          }
          
          // Reset other columns from previous hover
          columns.forEach((otherColumn, otherIndex) => {
            if (otherIndex !== currentHoveredIndex && otherIndex !== index) {
              const otherCard = otherColumn.querySelector('.ward-product-card');
              const otherImage = otherCard ? otherCard.querySelector('.ward-product-image') : null;
              
              otherColumn.style.setProperty('flex', defaultFlex, 'important');
              otherColumn.style.setProperty('max-width', defaultMaxWidth, 'important');
              
              if (otherImage) {
                // Ensure other images are visible
                gsap.to(otherImage, {
                  opacity: 1,
                  visibility: 'visible',
                  duration: 0.2,
                  ease: 'power2.out'
                });
                // Also set directly to ensure visibility
                otherImage.style.opacity = '1';
                otherImage.style.visibility = 'visible';
              }
            }
          });
        }
        
        // Set current hovered index
        currentHoveredIndex = index;
        
        // Immediately set hovered card to expand (no delay)
        column.style.setProperty('flex', '0 0 66.666667%', 'important');
        column.style.setProperty('max-width', '66.666667%', 'important');
        
        // Animate image wrapper padding and justify-content
        if (imageWrapper) {
          imageWrapper.style.setProperty('justify-content', isRapide ? 'right' : 'left', 'important');

          // Animate image scale - ensure it's visible
          if (productImage) {
            // Make sure image is visible
            productImage.style.opacity = '1';
            productImage.style.visibility = 'visible';
            gsap.to(productImage, {
              scale: 1.2,
              opacity: 1,
              visibility: 'visible',
              duration: 0.2,
              ease: 'power2.out'
            });
          }
          
          // Animate padding and background scale
          gsap.to(imageWrapper, {
            paddingLeft: isRapide ? 40 : 130,
            paddingRight: isRapide ? 130 : 40,
            '--bg-scale': 1.05,
            duration: 0.3,
            ease: 'power2.out'
          });
        }
        
        // Fade in overlay
        if (overlay) {
          overlay.style.pointerEvents = 'auto';
          gsap.to(overlay, {
            opacity: 1,
            duration: 0.2,
            ease: 'power2.out'
          });
        }
        
        // Animate other columns to shrink
        columns.forEach((otherColumn, otherIndex) => {
          if (otherIndex !== index) {
            const otherCard = otherColumn.querySelector('.ward-product-card');
            const otherImage = otherCard ? otherCard.querySelector('.ward-product-image') : null;
            
            if (otherColumn) {
              otherColumn.style.setProperty('flex', '0 0 16.666667%', 'important');
              otherColumn.style.setProperty('max-width', '16.666667%', 'important');
            }
            
            // Hide other images
            if (otherImage) {
              gsap.to(otherImage, {
                opacity: 0,
                visibility: 'hidden',
                duration: 0.2,
                ease: 'power2.out'
              });
            }
          }
        });
      };
      
      // Hover leave handler
      const handleMouseLeave = function(e) {
        if (!wardProductHoverEnabled) return;
        if (e) {
          e.stopPropagation();
        }
        
        // Check if we're moving to another column in the same row
        const relatedTarget = e ? e.relatedTarget : null;
        const isMovingToAnotherColumn = relatedTarget && (
          relatedTarget.closest && (
            relatedTarget.closest('.col-12') === columns[(index + 1) % columns.length] ||
            relatedTarget.closest('.col-12') === columns[(index - 1 + columns.length) % columns.length] ||
            Array.from(columns).some(col => col.contains(relatedTarget))
          )
        );
        
        // If moving to another column, don't reset - let the enter handler handle it
        if (isMovingToAnotherColumn) {
          return;
        }
        
        // Clear current hovered index
        if (currentHoveredIndex === index) {
          currentHoveredIndex = null;
        }
        
        // Use a small delay to prevent flicker when moving between columns
        leaveTimeout = setTimeout(function() {
          // Double-check we're still not hovering (might have entered another column)
          if (currentHoveredIndex === index) return;
          
          // Reset hovered column
          column.style.setProperty('flex', defaultFlex, 'important');
          column.style.setProperty('max-width', defaultMaxWidth, 'important');
          
          if (imageWrapper) {
            imageWrapper.style.setProperty('justify-content', 'center', 'important');
            
            // Animate back padding and reset background scale
            gsap.to(imageWrapper, {
              paddingLeft: 20,
              paddingRight: 20,
              '--bg-scale': 1,
              duration: 0.3,
              ease: 'power2.out'
            });
          }
          
          if (productImage) {
            // Ensure image is visible when leaving
            gsap.to(productImage, {
              scale: 1,
              opacity: 1,
              visibility: 'visible',
              duration: 0.2,
              ease: 'power2.out'
            });
            // Also set directly to ensure it's visible
            productImage.style.opacity = '1';
            productImage.style.visibility = 'visible';
          }
          
          if (overlay) {
            gsap.to(overlay, {
              opacity: 0,
              duration: 0.2,
              ease: 'power2.out',
              onComplete: function() {
                overlay.style.pointerEvents = 'none';
              }
            });
          }
          
          // Reset other columns
          columns.forEach((otherColumn, otherIndex) => {
            if (otherIndex !== index) {
              const otherCard = otherColumn.querySelector('.ward-product-card');
              const otherImage = otherCard ? otherCard.querySelector('.ward-product-image') : null;
              
              if (otherColumn) {
                otherColumn.style.setProperty('flex', defaultFlex, 'important');
                otherColumn.style.setProperty('max-width', defaultMaxWidth, 'important');
              }
              
              if (otherImage) {
                // Ensure other images are visible
                gsap.to(otherImage, {
                  opacity: 1,
                  visibility: 'visible',
                  duration: 0.2,
                  ease: 'power2.out'
                });
                // Also set directly to ensure visibility
                otherImage.style.opacity = '1';
                otherImage.style.visibility = 'visible';
              }
            }
          });
        }, 50); // Small delay to check if we're moving to another column
      };
      
      // Attach hover primarily to the column element - use capture phase for immediate response
      column.addEventListener('mouseenter', handleMouseEnter, { passive: false, capture: true });
      column.addEventListener('mouseleave', handleMouseLeave, { passive: false, capture: true });
      
      // Also attach to card as backup
      if (card) {
        card.addEventListener('mouseenter', handleMouseEnter, { passive: false, capture: true });
        card.addEventListener('mouseleave', handleMouseLeave, { passive: false, capture: true });
      }
    });
  });
}

// Cart Updates
function initCartUpdates() {
  const addToCartBtn = document.getElementById('add-to-cart-btn');
  const cartCount = document.getElementById('cart-count');

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      // Animate button click
      gsap.to(this, {
        scale: 0.95,
        duration: 0.1,
        yoyo: true,
        repeat: 1
      });

      // Update cart count animation
      if (cartCount) {
        gsap.to(cartCount, {
          scale: 1.3,
          duration: 0.2,
          yoyo: true,
          repeat: 1
        });
      }
    });
  }
}

// Add to Cart Form Handler
const productForm = document.getElementById('product-form');
if (productForm) {
  productForm.addEventListener('submit', async function(e) {
    e.preventDefault();
    
    const formData = new FormData(this);
    const addToCartBtn = document.getElementById('add-to-cart-btn');
    
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';
    }

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        // Success animation
        if (addToCartBtn) {
          addToCartBtn.classList.add('btn-preorder--added');
          addToCartBtn.textContent = 'ADDED TO CART';

          // Small bounce animation on success
          gsap.fromTo(addToCartBtn,
            { scale: 1 },
            { scale: 1.03, duration: 0.15, yoyo: true, repeat: 1, ease: 'power1.out' }
          );

          // After a short delay, revert back to initial state
          setTimeout(() => {
            addToCartBtn.classList.remove('btn-preorder--added');
            addToCartBtn.textContent = 'PRE-ORDER';
          }, 2000);
        }

        // Update cart count
        const cart = await fetch(window.routes.cart_url + '.js').then(r => r.json());
        const cartCountEl = document.getElementById('cart-count');
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
          cartCountEl.classList.add('updated');
          setTimeout(() => cartCountEl.classList.remove('updated'), 500);
        }
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Failed to add product to cart. Please try again.');
    } finally {
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
      }
    }
  });
}

// Mobile Menu Toggle
function initMobileMenu() {
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const menuClose = document.querySelector('.mobile-menu-close');
  
  if (!menuToggle || !mobileMenu) return;
  
  function closeMenu() {
    mobileMenu.classList.remove('active');
    document.body.classList.remove('menu-open');
  }
  
  function openMenu() {
    mobileMenu.classList.add('active');
    document.body.classList.add('menu-open');
  }
  
  menuToggle.addEventListener('click', function(e) {
    e.stopPropagation();
    if (mobileMenu.classList.contains('active')) {
      closeMenu();
    } else {
      openMenu();
    }
  });
  
  if (menuClose) {
    menuClose.addEventListener('click', function(e) {
      e.stopPropagation();
      closeMenu();
    });
  }
  
  // Close menu when clicking outside
  document.addEventListener('click', function(e) {
    if (!mobileMenu.contains(e.target) && !menuToggle.contains(e.target)) {
      closeMenu();
    }
  });
  
  // Close menu when clicking on a menu link
  const menuLinks = mobileMenu.querySelectorAll('.mobile-menu-link');
  menuLinks.forEach(link => {
    link.addEventListener('click', function() {
      closeMenu();
    });
  });
}

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  });
});

/**
 * Scroll Animation for Ward Hero Banner
 * Replicates the pb-row-splash-page__header scroll animation
 */

(function() {
  'use strict';

  /**
   * Smooth scroll fallback implementation
   * Used when native smooth scroll or SiteScroll is not available
   */
  function smoothScrollTo(target, duration) {
    const start = window.pageYOffset;
    const distance = target - start;
    let startTime = null;

    function easeInOutQuart(t) {
      return t < 0.5 
        ? 8 * t * t * t * t 
        : 1 - Math.pow(-2 * t + 2, 4) / 2;
    }

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easeInOutQuart(progress);
      
      window.scrollTo(0, start + distance * ease);
      
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }

    requestAnimationFrame(animation);
  }

  // Wait for DOM to be ready
  function init() {
    const heroBanner = document.getElementById('shopify-section-template--19403881545882__hero-banner');
    
    if (!heroBanner) {
      console.warn('Hero banner section not found');
      return;
    }

    // Find all potential CTA elements that should scroll to hero
    // You can customize these selectors based on your needs
    const ctaSelectors = [
      '.ward-hero-cta',
      '.ward-scroll-to-hero',
      '[data-scroll-target="hero-banner"]',
      // Add more selectors as needed
    ];

    const ctaElements = [];
    ctaSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => ctaElements.push(el));
    });

    // If no specific CTAs found, you might want to add a default trigger
    // For now, we'll create a function that can be called programmatically

    /**
     * Scroll to hero banner with animation
     * @param {Object} options - Animation options
     * @param {number} options.duration - Animation duration in ms (default: 2500)
     * @param {string} options.easing - Easing function (default: "easeInOutQuart")
     */
    function scrollToHeroBanner(options = {}) {
      const scrollY = window.scrollY;
      const heroRect = heroBanner.getBoundingClientRect();
      const heroHeight = heroRect.height;
      
      const config = {
        speed: options.duration || 2500,
        scrollOffset: 0
      };

      // If already scrolled, use faster animation
      if (scrollY > 0) {
        config.scrollOffset = 0;
        config.speed = options.duration || 1000; // 1 second
      } else {
        config.scrollOffset = heroHeight;
      }

      // Try to use the existing SiteScroll system (from the original codebase)
      // Method 1: Direct SiteScroll object
      if (window.SiteScroll && typeof window.SiteScroll.scrollTo === 'function') {
        window.SiteScroll.scrollTo(config.scrollOffset, {
          duration: config.speed,
          easing: options.easing || 'easeInOutQuart'
        });
        return;
      }
      
      // Method 2: Event emitter pattern (matches original implementation)
      // Look for emitter in various possible locations
      const emitter = window.emitter || 
                     (window.Site && window.Site.emitter) ||
                     (window.App && window.App.emitter);
      
      if (emitter && typeof emitter.emit === 'function') {
        emitter.emit('SiteScroll.scrollTo', config.scrollOffset, {
          duration: config.speed,
          easing: options.easing || 'easeInOutQuart'
        });
        return;
      }
      
      // Method 3: Custom scroll implementation with easing
      // Fallback: Use native smooth scroll if SiteScroll is not available
      const targetPosition = heroBanner.offsetTop;
      
      // Try native smooth scroll first
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      } 
      // Fallback: Manual smooth scroll animation
      else {
        smoothScrollTo(targetPosition, config.speed);
      }
    }

    // Add click handlers to CTA elements
    function handleCtaClick(event) {
      event.preventDefault();
      event.stopPropagation();
      scrollToHeroBanner();
    }

    // Bind click events to all CTA elements
    ctaElements.forEach(element => {
      element.addEventListener('click', handleCtaClick);
    });

    // Expose the scroll function globally for programmatic use
    window.scrollToHeroBanner = scrollToHeroBanner;

    // Optional: Add data attribute to hero banner for scroll targeting
    heroBanner.setAttribute('data-scroll-target', 'hero-banner');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
